import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Vuelidate from "vuelidate";
import config from './config';

import cover from 'cover/lib/cover'
import 'cover/lib/cover.css'

Vue.use(cover)
Vue.use(Vuelidate);

Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.prototype.$cfg = config;

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$axios.defaults.headers.common['Authorization'] = token
}

Vue.prototype.$axios.interceptors.response.use(undefined, function (err) {

  return new Promise(function (resolve, reject) {

    if (typeof(err.response) != 'undefined' && err.response.status === 401) {
      // if you ever get an unauthorized, logout the user
      // also redirect to /login if needed !
      store.dispatch('logout').then(() => {
        router.push('/auth/login')
      });
    }else{

      Vue.prototype.$notify({
        type: 'danger',
        title: 'API Error',
        content: err,
        closeable: true,
        duration: 5000
      });
      
    }




    throw err;
  });
});

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
